import React from 'react'
import { JadwalServiceDetailServicePage } from '..'

const MekanikJadwalServiceDetailServicePage = () => {
  return <JadwalServiceDetailServicePage isMechanicView={true} />
}

export default MekanikJadwalServiceDetailServicePage
